import MyProducts from './my-products-container';

export default MyProducts;